import { EntraButton } from "metabase/auth/components/EntraButton";
import {
  PLUGIN_AUTH_PROVIDERS,
  PLUGIN_IS_PASSWORD_USER,
} from "metabase/plugins";
import MetabaseSettings from "metabase/utils/settings";

PLUGIN_AUTH_PROVIDERS.providers.push((providers) => {
  const entraProvider = {
    name: "entra",
    Button: EntraButton,
  };

  return MetabaseSettings.get("entra-enabled")
    ? [entraProvider, ...providers]
    : providers;
});

PLUGIN_IS_PASSWORD_USER.push((user) => user.sso_source !== "entra");
